import {desksAdapter, suggestedDesksAdapter} from './adapters';
import {DesksSliceState, DesksState, SuggestedDesksState} from './types';

export const initialState: DesksSliceState = {
  list: <DesksState>desksAdapter.getInitialState({
    isLoading: false,
  }),
  suggestedDesks: <SuggestedDesksState>suggestedDesksAdapter.getInitialState({
    isLoading: false,
  }),
  deskBookingStatus: {
    entities: {},
    isLoading: false,
  },
  isLoadingDeskByAreaId: false,
  isLoadingDeskSuggestions: false,
  suggestedDeskIds: [],
  suggestionError: undefined,
};
